"use client";

import Link from "next/link";
import { ComponentProps, ReactNode } from "react";

/* Page transitions removed (Sagar 2026-06-13): the next-view-transitions
 * + GSAP clip-path animation made every nav click feel slow (1.5s
 * animated route change). TransitionLink is now a plain next/link, so
 * navigation is instant client-side routing. The exports are kept (same
 * names, used across the app) but are no-ops now. */

interface TransitionLinkProps extends ComponentProps<typeof Link> {
  children: ReactNode;
  className?: string;
}

export const TransitionLink = ({ children, ...props }: TransitionLinkProps) => {
  return <Link {...props}>{children}</Link>;
};

/* No-op: kept so existing imports don't break. */
export const PageLoadRevealer = () => null;

export function PageTransition({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

export function triggerPageTransition() {
  /* intentionally empty — transitions disabled */
}
